import { DEFAULT_CURRENCY_CODE, LOCALE_ID, Provider } from '@angular/core';
import { countryIso2CodeFactory } from '../factories/country-iso-2-code/country-iso-2-code.factory';
import { countryIso3CodeFactory } from '../factories/country-iso-3-code/country-iso-3-code.factory';
import { countryIsoNumberFactory } from '../factories/country-iso-number/country-iso-number.factory';
import { countryNameFactory } from '../factories/country-name/country-name.factory';
import { defaultCurrencyCodeFactory } from '../factories/default-currency-code/default-currency-code.factory';
import { localeIdFactory } from '../factories/locale-id/locale-id.factory';
import { provinceNamesFactory } from '../factories/province-names/province-names.factory';
import { I18nModuleConfig } from '../models/config/i18n-module-config.interface';
import { CountryIsoNumber } from '../models/country/country-iso-number.enum';
import { COUNTRY_ISO_2_CODE } from '../tokens/country-iso-2-code.token';
import { COUNTRY_ISO_3_CODE } from '../tokens/country-iso-3-code.token';
import { COUNTRY_ISO_NUMBER } from '../tokens/country-iso-number.token';
import { COUNTRY_NAME } from '../tokens/country-name.token';
import { PROVINCE_NAMES } from '../tokens/province-names.token';
import { provideTranslationDictionaryMapping } from '../utils/translation-dictionary/translation-dictionary.utils';

export function provideI18nDefaults(config?: I18nModuleConfig): Provider {
  return [
    {
      provide: COUNTRY_ISO_2_CODE,
      useFactory: countryIso2CodeFactory,
      deps: [COUNTRY_ISO_NUMBER],
    },
    {
      provide: COUNTRY_ISO_3_CODE,
      useFactory: countryIso3CodeFactory,
      deps: [COUNTRY_ISO_NUMBER],
    },
    {
      provide: COUNTRY_ISO_NUMBER,
      useFactory: () => countryIsoNumberFactory(config?.countryIsoNumber),
    },
    {
      provide: COUNTRY_NAME,
      useFactory: countryNameFactory,
      deps: [COUNTRY_ISO_NUMBER],
    },
    {
      provide: DEFAULT_CURRENCY_CODE,
      useFactory: defaultCurrencyCodeFactory,
      deps: [COUNTRY_ISO_NUMBER],
    },
    {
      provide: PROVINCE_NAMES,
      useFactory: provinceNamesFactory,
      deps: [COUNTRY_ISO_NUMBER],
    },
    {
      provide: LOCALE_ID,
      useFactory: (countryIsoNumber: CountryIsoNumber) =>
        localeIdFactory(countryIsoNumber, config?.localeId),
      deps: [COUNTRY_ISO_NUMBER],
    },
    provideTranslationDictionaryMapping(config?.translationDictionaryMapping),
  ];
}
